import { useState } from "react";
import { GroupedOption } from "../../../helpers/types/common";

export default function useMuiGroupedSelect(
  options: GroupedOption[],
  showSearch: boolean,
) {
  const [filterText, setFilterText] = useState("");
  const [menuWidth, setMenuWidth] = useState<string | number>("auto");

  const groupMap = options.reduce<Record<string, GroupedOption[]>>(
    (acc, curr) => {
      if (!acc[curr.groupBy]) acc[curr.groupBy] = [];
      acc[curr.groupBy].push(curr);
      return acc;
    },
    {},
  );

  const filteredGroupMap = Object.entries(groupMap).reduce<
    Record<string, GroupedOption[]>
  >((acc, [group, opts]) => {
    const filtered = showSearch
      ? opts.filter((opt) =>
          opt.name.toLowerCase().includes(filterText.toLowerCase()),
        )
      : opts;
    if (filtered.length) acc[group] = filtered;
    return acc;
  }, {});

  const handleSearchFilterChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setFilterText(event.target.value);
  };

  const handleSearchKeyDown = (
    event: React.KeyboardEvent<HTMLInputElement>,
  ) => {
    event.stopPropagation();
  };

  const handleOpen = (event: React.SyntheticEvent<Element, Event>) => {
    const selectBox = event.currentTarget.getBoundingClientRect();
    setMenuWidth(selectBox.width);
    setFilterText("");
  };

  const handleInputClick = (event: React.MouseEvent<HTMLInputElement>) => {
    event.stopPropagation();
  };

  const allGroupBy = options.map((opt) => opt.groupBy);
  const isSingleGroup = allGroupBy.every((g) => g === allGroupBy[0]);

  return {
    filterText,
    setFilterText,
    menuWidth,
    handleSearchFilterChange,
    handleSearchKeyDown,
    handleOpen,
    handleInputClick,
    filteredGroupMap,
    isSingleGroup,
  };
}
